module.exports = __webpack_public_path__ + "static/media/configuracoes.46def3d3.png";